
import "../css/card_design.css";
import "../css/Nav design.css";
import { useLocation } from "react-router-dom";
import ApiConfig from '../utils/ApiConfig';
import UpdateDetailsResponse from "../model/response/UpdateDetailsResponse";
import UpdateDetails from "../model/request/UpdateDetails";
import axios from 'axios';
import LookUpRequest from "../model/request/LookupRequest";
import ApiResponse from '../model/response/ApiResponse';
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';
import { Oval } from "react-loader-spinner";
import { useEffect, useState, useRef } from "react";






function Religion_details() {
  var location = useLocation();
  var { profile } = location.state || {};

  const [activeuser, setActiveUser] = useState([]);
  const [religion, setReligion] = useState(profile.religionId);
  const [Caste, setCaste] = useState(profile.casteId);
  const [subCaste, setSubcaste] = useState(profile.sub_Caste);
  const [Gothram, setGothram] = useState(profile.gothram);
  //  const [star, setStar] = useState(profile.horoscope);
  //  const [raasi, setRaasi] = useState(profile.horoscope);
  const [timeofBirth, setTimeofbirth] = useState(profile.date_Of_Birth);
  var [Country, setCountry] = useState(profile.country_Id);
  var [stateList, setStateList] = useState([]);
  var [State, setState] = useState(profile.state_Id);
  var [StateItem, setStateItem] = useState("");
  var [StateId, setStateId] = useState("");
  var [districtList, setDistrictList] = useState([]);
  var [District, setDistrict] = useState(profile.city);
  var [DistrictId, setDistrictId] = useState("");
  var [casteList, setCasteList] = useState([]);
  var [time, setTime] = useState(profile.time_of_birth);
  const [placeofbirth, setPlaceofBirth] = useState(profile.place_of_Birth);
  const [isLoading, setIsLoading] = useState(false)
  // State variables
  const [suggestions, setSuggestions] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [searchTimer, setSearchTimer] = useState(null); // Debounce-க்காக

  const handlePlaceSearch = (query) => {
    setPlaceofBirth(query);

    // பழைய Timer-ஐ Clear செய்ய
    if (searchTimer) clearTimeout(searchTimer);

    if (query.trim().length > 2) {
      setIsSearching(true);

      // பயனர் டைப் செய்து முடித்த 400ms கழித்து மட்டுமே API Call செல்லும் (Debounce)
      const newTimer = setTimeout(async () => {
        try {
          const response = await axios.get(
            `https://photon.komoot.io/api/?q=${encodeURIComponent(query)}&limit=5`
          );

          // Photon API Response Formatting
          const results = response.data.features.map((item) => {
            const p = item.properties;
            return [p.name, p.city, p.state, p.country].filter(Boolean).join(", ");
          });

          setSuggestions(results);
        } catch (error) {
          console.error("Error fetching places:", error);
        } finally {
          setIsSearching(false);
        }
      }, 400);

      setSearchTimer(newTimer);
    } else {
      setSuggestions([]);
      setIsSearching(false);
    }
  };


  const navigation = useNavigate()

  function clicktoEditprofile() {
    navigation('/Editprofile')

    setIsLoading(true);
  }


  const rawVal = localStorage.getItem('loginVal');
  let loginVal = rawVal ? JSON.parse(rawVal) : null;
  let token = loginVal ? loginVal.token : null;


  function showToast(message) {
    toast.success(message, {
      position: "top-right",
      autoClose: 2000
    });
  }
  function showToastFailed(message) {
    toast.error(message, {
      position: "top-right",
      autoClose: 2000
    });
  }




  useEffect(() => {
    console.log('caste:' + Caste, 'religion:' + religion);

    casteAPICall(religion);
    stateAPICall();
  }, [])


  function Religion_detailsAPICall() {

    setIsLoading(true);

    var request = new UpdateDetails();

    request.user_Id = loginVal.user_Id;
    request.religion = religion;
    request.caste = Caste;
    request.subCaste = subCaste;
    request.gothram = Gothram;
    request.time_of_Birth = time;
    console.log("PLACE BEFORE API:", placeofbirth);
    request.place_of_Birth = placeofbirth;


    axios.put(
      ApiConfig.getUrl("User/updateReligion"),
      JSON.stringify(request),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    )
      .then(response => {

        console.log("API RESPONSE:", response.data);

        const api = ApiResponse.fromJson(response.data);

        const profileVal =
          UpdateDetailsResponse.fromJson(api.response);

        // =====================================
        // SAVE BIRTH TIME
        // =====================================

        if (time) {

          const formattedTime = time.toString().trim();

          localStorage.setItem(
            "user_time_of_birth",
            formattedTime
          );

          console.log(
            "TIME SAVED:",
            localStorage.getItem("user_time_of_birth")
          );

        } else {

          console.log("TIME IS EMPTY:", time);

        }

        if (placeofbirth) {
          const formattedPlace = placeofbirth.toString().trim();

          localStorage.setItem(
            "user_place_of_birth",
            formattedPlace
          );

          console.log(
            "PLACE SAVED:",
            localStorage.getItem("user_place_of_birth")
          );
        }



        setActiveUser(profileVal);

        showToast("Update successfull");

        setIsLoading(false);
      })
      .catch(error => {

        console.error("Error:", error);

        showToastFailed("Update Error");

        setIsLoading(false);
      });
  }




  function stateAPICall() {
    var request = new LookUpRequest();
    request.countrycode = "IN";
    console.log("Response:", JSON.stringify(request));
    axios.post(
      ApiConfig.getUrl("User/state"),
      JSON.stringify(request),
      {
        headers: {
          "Content-Type": "application/json",
        }
      }
    )
      .then(response => {
        // setStateList(response.dataList)
        console.log("Responsesadsadsad:", response.data.response);
        const dataList = response.data.response.dataList;
        console.log("Responsesa:", dataList);
        setStateList(dataList)
        // navigation('/Verify', { state: { userRegister: userObject } })

      })
      .catch(error => {
        console.error("Error:", error);
      });
  }

  function districtAPICall(code) {
    var request = new LookUpRequest();
    request.state_code = code;
    console.log("Response:", JSON.stringify(request));
    axios.post(
      ApiConfig.getUrl("User/district"),
      JSON.stringify(request),
      {
        headers: {
          "Content-Type": "application/json",
        }
      }
    )
      .then(response => {
        console.log("Responsesadsadsad:", response.data.response);
        const dataList = response.data.response.dataList;
        console.log("Responsesa:", dataList);
        setDistrictList(dataList)

      })
      .catch(error => {
        console.error("Error:", error);
      });
  }
  function casteAPICall(religionId) {
    var request = new LookUpRequest();
    request.religion_id = religionId;
    console.log("Response:", JSON.stringify(request));
    axios.post(
      ApiConfig.getUrl("User/caste"),
      JSON.stringify(request),
      {
        headers: {
          "Content-Type": "application/json",
        }
      }
    )
      .then(response => {
        console.log("Responsesadsadsad:", response.data.response);
        const dataList = response.data.response.dataList;
        console.log("Responsesa:", dataList);
        setCasteList(dataList)

      })
      .catch(error => {
        console.error("Error:", error);
      });
  }



  const disableRightClick = (e) => {
    e.preventDefault();
  };


  return (
    <>
      <div onContextMenu={disableRightClick}>
        <ToastContainer />


        <div className="fullview" style={{ fontFamily: " font-family: Arial, Helvetica, sans-serif" }}>
          {isLoading && (
            <div className="loader-overlay">
              <Oval
                height={60}
                width={60}
                color="#ffffff"
                secondaryColor="#cccccc"
                strokeWidth={4}
                visible={true}
              />
            </div>
          )}

          < div className="container border p-5">

            <div className='topic-row'>
              <h2>Religion Information</h2>
              <button className="Edit-btn" onClick={clicktoEditprofile}>Close</button></div>


            <div className="card-row">
              <div className="left-label">
                <label htmlFor="Religion" id="Religion" >Religion:</label>
              </div>
              <div>
                <select id="Religion" className="input_box" value={religion} onChange={(e) => {
                  setReligion(parseInt(e.target.value))
                  // if(e.target.value!=""){
                  casteAPICall(parseInt(e.target.value))
                  // }
                }} >

                  <option value="1">Hindu</option>
                  <option value="2">Muslim</option>
                  <option value="3">Muslim - Shia</option>
                  <option value="4">Muslim - Sunni</option>
                  <option value="6">Christian</option>
                  <option value="7">Sikh</option>
                  <option value="8">Jain - All</option>
                  <option value="9">Jain - Digambar</option>
                  <option value="10">Jain - Shwetambar</option>
                  <option value="12">Parsi</option>
                  <option value="13">Buddhist</option>
                  <option value="14">Jewish</option>
                  <option value="15">Inter-Religion</option>
                  <option value="16">No Religious Belief</option>

                </select></div></div>

            <div className="card-row">
              <div className="left-label">
                <label htmlFor="Caste" id="Caste" className="label_box">Division/Caste:</label>
              </div>
              <div>
                <select id="Caste" className="input_box" value={Caste}
                  onChange={(e) => {
                    setCaste(parseInt(e.target.value))

                  }}>

                  {casteList.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select></div></div>


            <div className="card-row">
              <div className="left-label">
                <label htmlFor="Subcaste" id="Subcaste" className="label_box">Subcaste:</label>
              </div>
              <div>
                <input type="text" className="input_box border" placeholder='Subcaste' value={subCaste} onChange={(e) => setSubcaste(e.target.value)} /></div>
              <div>
              </div></div>

            <div className="card-row">
              <div className="left-label">
                <label htmlFor="Gothram" id="Gothram" className="label_box">Gothram:</label>
              </div>
              <div>
                <input type="text" id="Gothram" className="input_box border"
                  placeholder='Gothram'
                  value={Gothram} onChange={(e) => setGothram(e.target.value)} />

              </div></div>



            <div className="card-row">
              <div className="left-label">
                <label htmlFor="time" id="time" className="label_box">Time of Birth:</label>
              </div>
              <div>
                <input type="time" id="time" className="input_box border"
                  placeholder='Time of Birth' value={time}
                  onChange={(e) => setTime(e.target.value)}
                />

              </div></div>
            <div className="card-row">
              <div className="left-label">
                <label className="label_box">Place of Birth :</label>
              </div>

              <div>
                <input 
                  type="text"
                  className="input_box border"
                  placeholder="Search Place of Birth"
                  value={placeofbirth || ""}
                  onChange={(e) => handlePlaceSearch(e.target.value)}
                  onBlur={() => setTimeout(() => setSuggestions([]), 200)}
                />

                {isSearching && (
                  <small style={{ position: "absolute", right: "10px", top: "10px", color: "#888" }}>
                    Loading...
                  </small>
                )}

                {suggestions.length > 0 && (
                  <ul
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      backgroundColor: "#fff",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      maxHeight: "150px",
                      overflowY: "auto",
                      zIndex: 1000,
                      listStyle: "none",
                      padding: 0,
                      margin: 0,
                      boxShadow: "0px 4px 6px rgba(0,0,0,0.1)"
                    }}
                  >
                    {suggestions.map((placeName, index) => (
                      <li
                        key={index}
                        style={{
                          padding: "8px 12px",
                          cursor: "pointer",
                          borderBottom: "1px solid #eee",
                          fontSize: "14px"
                        }}
                        onMouseDown={() => {
                          setPlaceofBirth(placeName);
                          setSuggestions([]);
                        }}
                      >
                        {placeName}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
            {/* <p><input type="radio" name="radio" />
      <label htmlFor="same" >Willing to marry from the same community</label><br /><br />
        <input type="radio" name="radio" />
      <label htmlFor="other">Willing to marry from other communities also</label></p> */}

            {/* <div className="card-row">
        <div className="left-label">
          <label htmlFor="Star" id="Star" className="label_box">Star:</label>
        </div>
        <div>
          <select id="Star" className="input_box"  value={star} onChange={(e)=>setStar(e.target.value)}>
            <option value=""> -Select-</option>
            <option value="1"></option>
            <option value="2"></option>
            <option value="3"></option>
            <option value="4"></option>
            <option value="5"></option>
          </select></div></div>
      <div className="card-row">
        <div className="left-label">
          <label htmlFor="Raasi" id="Raasi" className="label_box">Raasi / Moon Sign :</label>
        </div>
        <div>
          <select id="Raasi" className="input_box"  value={raasi} onChange={(e)=>setRaasi(e.target.value)}>
            <option value=""> -Select-</option>
            <option value="1"></option>
            <option value="2"></option>
            <option value="3"></option>
            <option value="4"></option>
            <option value="5"></option>
          </select></div></div>
      <div className="card-row">
        <div className="left-label">
          <label htmlFor="Zodiac " id="Zodiac" className="label_box">Zodiac / Star Sign :</label>
        </div>
        <div>
          <select id="Zodiac" className="input_box" value={star} onChange={(e)=>setStar(e.target.value)}>
            <option value=""> -Select-</option>
            <option value="1"></option>
            <option value="2"></option>
            <option value="3"></option>
            <option value="4"></option>
            <option value="5"></option>
          </select></div></div>


      <h2>Horoscope Details</h2>
      <div className="card-row">
        <div className="left-label">
          <label htmlFor="Time " id="Time" className="label_box">Time of Birth :</label>
        </div>
        <div>
          <input type="Time" name="Time" className="input_box"  value={timeofBirth} onChange={(e)=>setTimeofbirth(e.target.value)}/></div></div> */}
            {/* <div className="card-row">
        <div className="left-label">
          <label htmlFor="Place " id="Place" className="label_box">Place of Birth :</label>
        </div>

        <div className="right-label">
          <select id="Country" className="input_box" value={Country} onChange={(e) => setCountry(e.target.value)}>
                    <option value="">--Country-- </option>
                    <option value="IN">India</option>
                </select>
               


          <select id="State" className="input_box" value={State}
                    onChange={(e) => {
                        // console.log("Responsesadsadsad:", e.target.key);
                        // const obj = JSON.parse(e.target.value);

                        const selectedState = stateList.find(s => s.code === e.target.value);
                        setStateItem(selectedState);
                        setState(selectedState.code);
                        setStateId(selectedState.id);
                        districtAPICall(e.target.value);
                        console.log("Responsesadsadsad:", e.target.value);
                        // }
                    }}>
                    <option value="">--State--</option>
                    {stateList.map((item) => (
                        <option key={item.id} value={item.code}>
                            {item.name}
                        </option>
                    ))}
                </select>

         <select id="District" className="input_box" value={District}
                    onChange={(e) => {
                        setDistrict(e.target.value)
                        console.log("Responsesadsadsad:", e.target.value);
                        setDistrictId(e.target.value)
                    }}>
                    <option value="">--District--</option>
                    {districtList.map((item) => (
                        <option key={item.id} value={item.id}>
                            {item.name}
                        </option>
                    ))}
                </select></div></div> */}

            <div className="btn-group mt-3">
              <button style={{ backgroundColor: "var(--primary-color)" }} onClick={Religion_detailsAPICall} className="btn">Save</button>
              <button style={{ backgroundColor: "lightgrey" }} className="btn" onClick={clicktoEditprofile}>Cancel</button>
            </div>
          </div>
        </div>
      </div>
      <footer className='bg-dark text-white text-center '>
        <label style={{ fontSize: "12px" }}>Copyright © 2026 NavGraph Technologies. All Rights Reserved.</label>
      </footer>
    </>

  );
}
export default Religion_details;